import React, { FC, useEffect, useState } from 'react'
import { Cookie } from 'Pages/landings/newLandings/common/components'
import { OutLinks } from 'Pages/landings/newLandings/common/constants'
import { Wrapper, Text, TextLink, Button } from './styled'

export const CookieHandlingNotice: FC = () => {
	const [isCheck, setIsCheck] = useState<boolean>(false)
	useEffect(() => {
		if (isCheck)
			Cookie.set('cookie_handling_notice', 'true', {
				secure: 'true',
				path: '/',
				'max-age': '2592000',
			})
	}, [Boolean(Cookie.get('cookie_handling_notice')), isCheck])

	return (
		!isCheck &&
		!Cookie.get('cookie_handling_notice') && (
			<Wrapper>
				<Text>
					Деловая среда обрабатывает Cookies с целью персонализации сервисов и повышения удобства
					пользования веб-сайтом. Ограничить обработку Cookies можно в настройках Вашего браузера.
					Пожалуйста, ознакомьтесь с
					<TextLink onClick={() => window.open(OutLinks.cookie_policy, '_blank')}>
						&nbsp;Политикой использования Cookies
					</TextLink>
				</Text>
				<Button type="primary" measure="m" text="Принять" onClick={() => setIsCheck(true)} />
			</Wrapper>
		)
	)
}
